<template>
  <div class="el-checkbox-group" role="group" aria-label="checkbox-group">
    <template v-if="checkBoxType == 'checkbox-button'">
      <el-checkbox-button v-for="item in defaultData" :key="item.value" :label="item.value" :disabled="item.disabled">
        {{ item.label }}
      </el-checkbox-button>
    </template>
    <template v-else>
      <el-checkbox v-for="item in defaultData" :key="item.value" :label="item.value" :disabled="item.disabled">
        {{ item.label }}
      </el-checkbox>
    </template>
  </div>
</template>

<script>
import { CheckboxGroup, Checkbox, CheckboxButton } from 'element-ui'

export default {
  name: 'WkCheckBoxGroup',
  extends: CheckboxGroup,
  props: {
    defaultData: {
      type: Array,
      default: () => []
    },
    checkBoxType: {
      type: String,
      default: 'checkbox-button'
    }
  }
}
</script>
<style lang="scss" scoped>
.el-checkbox-group::v-deep .el-checkbox-button.is-disabled.is-checked .el-checkbox-button__inner {
  background-color: #95c8fd;
  border-color: #c1d3ff;
  color: #fff;
}
</style>
